import { Appointment } from '../../../../../domain/entities';
import { formatTime } from '../../../../../utils/dates';

import styles from './AppointmentComponent.module.css';

const AppointmentComponent = ({ data }: any) => {
  const appointment = data as Appointment;

  return (
    <div className={styles.content}>
      <div className={styles.container}>
        <div className={styles.title}>
          {appointment.specialty.name} - {appointment.doctor.name}
        </div>
        <div className={styles.textContainer}>
          <div className={styles.text}>{appointment.patient.name}</div>
          <div className={styles.time}>{formatTime(appointment.startDate)}</div>
          <div className={styles.time}> - </div>
          <div className={styles.time}>{formatTime(appointment.endDate)}</div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentComponent;
